<script setup lang="ts">
declare const OneSignal: any;

const config = useRuntimeConfig();
const { $auth } = useAuth();
const { $alert } = useAlerts();
const { $t } = useLocalization();

const enabled = computed(() =>
{
    return config.public.onesignal && config.public.onesignal.length > 0;
});

const userIdentity = computed(() => $auth.user());

function subscribe(): void
{
    if (!OneSignal.isPushNotificationsSupported())
    {
        $alert.warning($t('[[[Przeglądarka z której korzystasz nie wspiera powiadomień PUSH]]]'));

        return;
    }

    OneSignal.showNativePrompt();
}

onMounted(() =>
{
    if (enabled.value)
    {
        OneSignal.push(() =>
        {
            OneSignal.init({
                appId: config.public.onesignal,
                allowLocalhostAsSecureOrigin: !import.meta.env.PROD
            });

            OneSignal.on('subscriptionChange', (isSubscribed: boolean) =>
            {
                if (isSubscribed === true && userIdentity.value)
                {
                    OneSignal.sendTags({
                        subscriberId: userIdentity.value.publicId
                    });
                }
            });
        });

        subscribe();
    }
});
</script>

<template>
    <div v-if="false" />
</template>
